import PropTypes from 'prop-types'

import {useEffect, useState} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {connect} from 'react-redux'
import {createResource} from 'redux-json-api'

import {Stack} from '@mui/material'

import Button from '../../../../../shared_components/mui_base_components/button/Button'
import ButtonGroup from '../../../../../shared_components/mui_base_components/button/ButtonGroup'
import Email from '../../../../../shared_components/forms/v3/Email'
import InviteClientNotification from '../../../../../pro/src/components/clients/InviteClientNotification'
import MediumModal from '../../../../../shared_components/mui_base_components/modals/medium_modal/MediumModal'
import Name from '../../../../../shared_components/forms/v3/Name'
import Select from '../../../../../shared_components/forms/v3/Select'
import NewLoader from '../../../../../shared_components/NewLoader'
import routerUtils from '../../../../../lib/routerUtils'

import {useNotificationContext} from '../../../../../shared_components/notifications/NotificationContext'

import './addClient.scss'

const FREEMIUM = 'freemium'
const PREMIUM = 'premium'

export const AddClient = props => {
  const methods = useForm({
    defaultValues: {
      funeral_home: {value: ''},
      'advance-planner-first-name': '',
      'advance-planner-last-name': '',
      'first-name': '',
      'last-name': '',
      email: ''
    },
    mode: 'onBlur'
  })

  const {alwaysNotify, dismissToastNotification} = useNotificationContext()

  const [processing, setProcessing] = useState(false)
  const emailValue = methods.watch('email')

  useEffect(() => {
    methods.clearErrors('email')
  }, [emailValue])

  const returnToClients = () => {
    if (props.onClientAdded)
      props.onClientAdded()
    routerUtils.push('pro/quarterback-admin/clients')
  }

  const showSuccessNotification = (client, formData) => {
    const firstName = formData['first-name']
    const lastName = formData['last-name']

    alwaysNotify.longSuccess(
      <InviteClientNotification
        count={1}
        dismissNotification={dismissToastNotification}
        isQuarterback={true}
        message={`${firstName} ${lastName} has been added`}
        recipients={[{client_seat_id: client['client-seat-ids'][0]}]}
      />
    )
  }

  const handleClose = () => {
    routerUtils.push('pro/quarterback-admin/clients')
  }

  const handleSubmit = formData => {
    setProcessing(true)

    const payload = {
      type: 'quarterback-clients',
      attributes: {
        'client-data': [{
          email: formData.email,
          'first-name': formData['first-name'],
          'last-name': formData['last-name']
        }],
        'firm-id': formData.funeral_home.value,
        'funeral-planner-first-name': formData['advance-planner-first-name'],
        'funeral-planner-last-name': formData['advance-planner-last-name'],
        'limited-client': formData.membership.value === FREEMIUM
      }
    }

    props.createResource(payload)
      .then(response => {
        showSuccessNotification(response.data.attributes, formData)
        returnToClients()
      })
      .catch(err => {
        setProcessing(false)

        const emailErrors = err.response.data.errors.map(error => error.title)

        methods.setError('email', {
          type: 'server',
          message: emailErrors[0]
        })
      })
  }

  return (
    <NewLoader loading={props.funeralHomes.length === 0}>
      <MediumModal className='add-client' open={true} onClose={handleClose}>
        <FormProvider {...methods}>
          <Stack component='form' spacing={2}>
            <Select
              name='funeral_home'
              label='Funeral Home'
              placeholder='Select one'
              required
              errorMessage='Please select a funeral home'
              options={props.funeralHomes.map(funeralHome => ({
                value: funeralHome.id,
                label: funeralHome.name
              }))}
              rules={{required: 'Please select a funeral home'}}
            />
            <Name
              firstNameProp='advance-planner-first-name'
              lastNameProp='advance-planner-last-name'
              label='Advance Planner'
              required
            />
            <Name
              firstNameProp='first-name'
              lastNameProp='last-name'
              required
            />
            <Email required />
            <Select
              name='membership'
              label='Membership'
              defaultValue={PREMIUM}
              placeholder='Select one'
              required
              errorMessage='Please select a membership'
              options={[
                {value: FREEMIUM, label: 'Freemium'},
                {value: PREMIUM, label: 'Premium'}
              ]}
              rules={{required: 'Please select a membership'}}
            />
          </Stack>
        </FormProvider>
        <ButtonGroup>
          <Button color='cancel' onClick={handleClose}>Cancel</Button>
          <Button
            loading={processing}
            onClick={methods.handleSubmit(handleSubmit)}>
          Add
          </Button>
        </ButtonGroup>
      </MediumModal>
    </NewLoader>
  )
}

AddClient.propTypes = {
  createResource: PropTypes.func.isRequired,
  funeralHomes: PropTypes.array,
  onClientAdded: PropTypes.func,
  readEndpoint: PropTypes.func.isRequired
}

export default connect(null, {createResource})(AddClient)
